import { MessageBox } from "element-ui";

export const Confirm = (message, title, options) => {
  return MessageBox.confirm(message, title || "提示", options);
};

export const Alert = (message, title, options) => {
  return MessageBox.alert(message, title || "提示", options);
};

export const BaseConfirm = async (text, opts = {}) => {
  const {
    confirmButtonText = "确定",
    cancelButtonText = "取消",
    type = "warning",
    dangerouslyUseHTMLString = false
  } = opts;
  try {
    await Confirm(text, "系统提示", {
      confirmButtonText,
      cancelButtonText,
      type,
      dangerouslyUseHTMLString
    });
    return true;
  } catch (error) {
    if (error === "cancel") return false;
  }
};
